import { useState } from "react";

function AudioPlayer({ word, roman }) {
  const [isPlaying, setIsPlaying] = useState(false);

  const speakText = (text, lang = 'ko-KR') => {
    if ('speechSynthesis' in window) {
      // Stop any currently playing speech
      window.speechSynthesis.cancel();
      
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = lang;
      utterance.rate = 0.7; // Slower for better Korean pronunciation
      utterance.pitch = 1.1; // Slightly higher pitch for clarity
      utterance.volume = 0.9; // Good volume level
      
      // Try to use a Korean voice if available
      const voices = window.speechSynthesis.getVoices();
      const koreanVoice = voices.find(voice => 
        voice.lang.startsWith('ko') || voice.name.includes('Korean')
      );
      if (koreanVoice) {
        utterance.voice = koreanVoice;
      }
      
      utterance.onstart = () => setIsPlaying(true);
      utterance.onend = () => setIsPlaying(false);
      utterance.onerror = () => setIsPlaying(false);
      
      window.speechSynthesis.speak(utterance);
    }
  };

  const handlePlay = () => {
    if (isPlaying) {
      window.speechSynthesis.cancel();
      setIsPlaying(false);
    } else {
      speakText(word);
    }
  };

  return (
    <div className="flex items-center justify-center space-x-4">
      <button
        onClick={handlePlay}
        className={`p-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-110 ${
          isPlaying
            ? "bg-red-600 text-white animate-pulse"
            : "bg-red-100 text-red-600 hover:bg-red-200"
        }`}
        disabled={isPlaying}
      >
        {isPlaying ? (
          <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        ) : (
          <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
          </svg>
        )}
      </button>
      <div className="text-center">
        <p className="text-lg font-semibold text-gray-700">{roman}</p>
        <p className="text-sm text-gray-500">Click to hear pronunciation</p>
      </div>
    </div>
  );
}

export default AudioPlayer;

